import { render } from "./PanelistSurveyCriterionPage.vue?vue&type=template&id=e482759c&ts=true"
import script from "./PanelistSurveyCriterionPage.vue?vue&type=script&lang=ts"
export * from "./PanelistSurveyCriterionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__